export default "__VITE_ASSET__mLPlvSdk__"